'use client'
import React, { useCallback, useState } from 'react'
import { debounce } from 'lodash-es'
import { toPairs } from 'ramda'

import { addEventTag } from 'helpers/utilities'
import useSearchHistory from 'helpers/useSearchHistory'
import { fetchSearchRemoteSuggestionService } from 'store/services/jobs/fetchSearchSuggestion'

import CommonSearchMobile from 'app/(new-pages)/components/Search/mobile/index.mobile'

const transObject = (params) => {
  const result = {}
  params.forEach((e, index) => {
    result[`query_histories[${index}]`] = e
  })
  return result
}

export const handleFilterSuggestionList = (suggestionList = []) => {
  return suggestionList.map((item) => {
    if (item?.length && typeof item === 'string') {
      return { value: item, label: item }
    }

    return {
      ...item,
      label: item?.value
    }
  })
}

const google_tags = ['hp_location_click', 'hp_search_focus', 'hp_search_click']

interface SearchInputMobileProps {
  langKey: string
  lang: any
}

const SearchInputMobile = (props: SearchInputMobileProps) => {
  const { langKey } = props
  const [query, setQuery] = React.useState('')
  const [suggestionList, setSuggestionList] = useState([])
  const [searchHistories, addSearchHistory, removeHistory] = useSearchHistory()
  const [selectQuery, setSelectQuery] = useState(null)
  const lang = props?.lang || {}
  const remotePage = lang?.remotePage || {}

  const onSearch = (value, option) => {
    const isEvent = !option
    const val = isEvent ? query : value
    if (option) {
      setSelectQuery(option)
    }

    addSearchHistory(val)
    setQuery(val)

    addEventTag(google_tags[2])

    if (option) {
      pushJobPage({ value: val, type: option?.type })
    } else {
      pushJobPage({ value: val, type: selectQuery?.type })
    }
  }

  const handleQuery = (val: string) => {
    setSelectQuery(null)
    setQuery(val)
    handleSuggestionSearch(val)
  }

  const pushJobPage = async ({ value = '', type = '' }) => {
    const keyWords = value?.trim?.().replace(/\s+/g, ' ')
    const words = (keyWords || '').trim()
    const url = new URLSearchParams(toPairs({ query: words })).toString()
    const urlPath = '/' + langKey + `/remote-jobs-hiring/job-search/` + (url ? '?' + url : '')
    window.location.href = urlPath
  }

  const handleSuggestionSearch = useCallback(
    debounce(async (val) => {
      const valueLength = val?.length ?? 0
      if (valueLength < 1) {
        setSuggestionList(searchHistories as any)
      } else {
        const qs = transObject(searchHistories)
        fetchSearchRemoteSuggestionService({ size: 5, query: val, ...qs }).then((data) => {
          const items = data?.data?.data?.items || []
          const result = items?.length ? items : searchHistories
          setSuggestionList(result)
        })
      }
    }, 300),
    [searchHistories]
  )

  const onFocus = () => {
    addEventTag(google_tags[1])
    if (!query?.length) {
      setSuggestionList(searchHistories as any)
    }
  }

  const handleClear = (value, type) => {
    if (type !== 'history') return
    let newSuggestionList = suggestionList.filter((item) => {
      if (item !== value?.data?.label) return item
    })
    // console.log("newSuggestionList", newSuggestionList);
    setSuggestionList(newSuggestionList)
    removeHistory(value?.data?.label)
  }

  return (
    <>
      <CommonSearchMobile
        query={query}
        setQuery={handleQuery}
        onSearch={onSearch}
        onClear={handleClear}
        placeholder={remotePage?.searchByJobTitle}
        suggestionList={handleFilterSuggestionList(suggestionList)}
        onFocus={onFocus}
        inputOptions={{
          companyGroupText: remotePage?.companyGroupText,
          jobTitleGroupText: remotePage?.jobTitleGroupText,
          historyGroupText: remotePage?.historyGroupText
        }}
      />
    </>
  )
}

export default SearchInputMobile
